import styled from "styled-components";

export const contentSx = {display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '10px'};
